module.exports = __webpack_public_path__ + "img/lingerie.1793bd11.svg";